<template>
  <div class="StyleGuide">
    <b-link :to="'/'" class="text-center d-block mb-2">
      <b-img src="../assets/vue-logo.png" width="40" class="logo"></b-img>
    </b-link>
    <h1 class="h1 text-center mb-5">Style Guide</h1>
    <b-container fluid>
      <b-row>
        <b-col>
          <h2 class="h1">Headings</h2>
          <h1>H1 - Industry 42px/50px</h1>
          <h2>H2 - Industry 36px/125%</h2>
          <h3>H3 - Roboto 32px/118%</h3>
          <h4>H4 - Roboto 26px/118%</h4>
          <h5>H5 - Roboto 22px/118%</h5>
          <h6>H6 - Roboto 45PX/118%</h6>
          <!-- eslint-disable-next-line -->
          <p><strong>Roboto 18px/133% (bold)</strong> - Lorem, ipsum dolor sit amet consectetur adipisicing elit. Fugiat, quis et. Nulla ex similique, aliquam eos laborum ut animi ducimus officia est temporibus harum eligendi dolore consequatur aliquid, tempora eaque.</p>
          <label>Label - Roboto 14px/133%</label>
        </b-col>
        <b-col class="light">
          <h2 class="h1">Buttons</h2>
          <p class="label">Defaults - Roboto</p>
          <b-button class="mr-3">Apply now</b-button>
          <b-button variant="secondary" class="mr-3">Apply now</b-button>
          <b-button variant="secondary">Apply now<b-icon-arrow-right /></b-button>
          <p class="label mt-5">Sizing - Roboto</p>
          <b-button variant="secondary" size="sm" class="mr-3">Small</b-button>
          <b-button variant="secondary" size="lg">Large</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6">
          <h2 class="h1">Form Elements</h2>
          <b-container fluid>
            <b-row>
              <b-col sm="6">
                <b-form-group id="input-group-1" label="Your Name" label-for="input-1">
                  <b-form-input
                    id="input-1"
                    v-model="form.name"
                    placeholder="Enter name"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group id="input-group-2" label="Your Email" label-for="input-2">
                  <b-form-input
                    id="input-2"
                    v-model="form.email"
                    type="email"
                    placeholder="Enter email"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group id="select-group-1" label="Dropdown 1" label-for="select-1">
                  <b-form-select
                    id="select-1"
                    v-model="form.selected_3"
                    :options="options">
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group id="select-group-2" label="Dropdown 2" label-for="select-2">
                  <b-form-select
                    id="select-2"
                    v-model="form.selected_4"
                    :options="options">
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group id="select-group-3" label="Dropdown 3" label-for="select-3">
                  <b-form-select
                    id="select-3"
                    v-model="form.selected_5"
                    :options="options">
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <b-form-group label="Checkbox example">
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="form.status"
                    name="checkbox-1"
                    value="accepted"
                    unchecked-value="not_accepted"
                  >
                    I accept the terms and use
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <b-form-group label="Inline radios (default)" v-slot="{ ariaDescribedby }">
                  <b-form-radio-group
                    v-model="form.selected"
                    :options="options"
                    :aria-describedby="ariaDescribedby"
                    name="radio-inline"
                  ></b-form-radio-group>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="Button style radios" v-slot="{ ariaDescribedby }">
                  <b-form-radio-group
                    id="btn-radios-1"
                    v-model="form.selected_2"
                    :options="options"
                    :aria-describedby="ariaDescribedby"
                    name="radios-btn-default"
                    buttons
                  ></b-form-radio-group>
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <b-form-group
                  label="Textarea"
                  label-for="textarea-formatter"
                  class="mb-0"
                >
                  <b-form-textarea
                    id="textarea-formatter"
                    v-model="form.text1"
                    placeholder="Enter your text"
                  ></b-form-textarea>
                </b-form-group>

              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: '',
        email: '',
        selected: '',
        selected_2: '',
        selected_3: '',
        selected_4: '',
        selected_5: '',
        status: 'not_accepted',
        text1: '',
      },
      options: [
        { text: 'S', value: 'first' },
        { text: 'M', value: 'second' },
        { text: 'L', value: 'third' },
        { text: 'XL', value: 'fourth' },
        { text: 'XXL', value: 'firth' },
        { text: 'XXXL', value: 'fifth' },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
  .StyleGuide {
    padding: 30px 20px;
  }
  .light {
    background-color: $gray-600;
  }
  .row {
    margin: 0 0 60px;
  }
</style>
